import { Pipe } from '@angular/core';
var SomePipe = (function () {
    function SomePipe() {
    }
    SomePipe.prototype.transform = function (input, predicate) {
        return Array.isArray(input) ? input.some(predicate) : input;
    };
    SomePipe.decorators = [
        { type: Pipe, args: [{ name: 'some' },] },
    ];
    /** @nocollapse */
    SomePipe.ctorParameters = function () { return []; };
    return SomePipe;
}());
export { SomePipe };
//# sourceMappingURL=some.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/some.js
// module id = 233
// module chunks = 4